import TemplateCards from './TemplateCards'
export default TemplateCards
